function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.433 1.338h38.792c1.535 0 2.77 1.323 2.77 2.967v47.467c0 1.643-1.235 2.967-2.77 2.967H8.433c-1.535 0-2.771-1.324-2.771-2.967V4.305c0-1.644 1.236-2.967 2.77-2.967z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.64 51.33V11.564h36.376V51.33zM43.188 4.747a1.136 1.136 0 112.273 0 1.136 1.136 0 01-2.273 0zM5.662 8.155h44.333M34.094 4.747a1.136 1.136 0 112.273 0 1.136 1.136 0 01-2.273 0zM38.641 4.747a1.136 1.136 0 112.273 0 1.136 1.136 0 01-2.273 0zM9.541 27.47h36.575"
}), /*#__PURE__*/React.createElement("g", {
  strokeWidth: 0.935
}, /*#__PURE__*/React.createElement("path", {
  d: "M-30.147 26.5c0-4.418 1.567-8 3.5-8s3.5 3.582 3.5 8zM-26.647 14v4M-29.653 14h6.011",
  transform: "matrix(1.1368 0 0 1.0065 52.436 .799)"
})), /*#__PURE__*/React.createElement("g", {
  strokeWidth: 0.935
}, /*#__PURE__*/React.createElement("path", {
  d: "M-30.147 26.5c0-4.418 1.567-8 3.5-8s3.5 3.582 3.5 8zM-26.647 14v4M-29.653 14h6.011",
  transform: "matrix(1.1368 0 0 1.0065 63.804 .799)"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M22.145 30.879c-5.022 0-9.094 4.07-9.094 9.09s4.072 9.089 9.094 9.089c2.14 0 4.094-.752 5.648-1.988a9.109 9.109 0 01-3.375-7.102 9.11 9.11 0 013.375-7.1 9.035 9.035 0 00-5.648-1.989z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.145 34.287c-3.14 0-5.684 2.543-5.684 5.68s2.545 5.682 5.684 5.682c1.31 0 2.484-.463 3.446-1.207a9.052 9.052 0 01-1.173-4.474c0-1.625.425-3.154 1.173-4.474-.962-.745-2.135-1.207-3.446-1.207z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.606 39.968c0 5.02-4.072 9.09-9.094 9.09s-9.094-4.07-9.094-9.09 4.072-9.09 9.094-9.09 9.094 4.07 9.094 9.09z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.196 39.968a5.682 5.682 0 01-5.684 5.68c-3.139 0-5.684-2.542-5.684-5.68s2.545-5.68 5.684-5.68a5.682 5.682 0 015.684 5.68z"
})));

var SvgDishwasher = function SvgDishwasher(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDishwasher, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Dishwasher.b4152c1b.svg";
export { ForwardRef as ReactComponent };